"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Shopify.theme.jsAjaxCart = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsAjaxCart = $.extend(this, Shopify.theme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {
      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');
      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        Shopify.theme.jsAjaxCart.showDrawer();
        return false;
      });
    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    // this.updateDiscountProgress()

    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      var $addToCartForm = $(this).closest('form');

      // update data variant value
      var parentForm = $addToCartForm;
      var $options = parentForm.find('.swatch_options');
      var options = '';
      $options.find('input:checked').each(function(i){
        const val = ( i == 0 ) ? $(this).val() : (` / ${$(this).val()}`);
        options += val;
      });

      $addToCartForm.find('[data-variant-selector] option').each(function (a, b) {
          if ($(this).html() == options ) { 
              $(this).prop('selected', true);
          };
      });
      
      Shopify.theme.jsAjaxCart.addToCart($addToCartForm);
      return false;
    });
    $(document).on('click', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      var lineID = $(this).parents('[data-line-item]').data('line-item');
      Shopify.theme.jsAjaxCart.removeFromCart(lineID);

      if (Shopify.theme.jsCart) {
        Shopify.theme.jsCart.removeFromCart(lineID);
      }

      return false;
    });
    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      Shopify.theme.jsAjaxCart.hideDrawer();
      Shopify.theme.jsAjaxCart.hideMiniCart();
      return false;
    });
  },
  showMiniCartOnHover: function showMiniCartOnHover() {
    var $el = $('[data-ajax-cart-trigger]');
    $el.hover(function () {
      if (Shopify.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
      } else {
        $el.addClass('show-mini-cart');
      }
    }, function () {
      $el.removeClass('show-mini-cart');
    });
  },
  hideMiniCart: function hideMiniCart() {
    if (this.cart_action != 'mini_cart') return false;
    var $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function toggleMiniCart() {
    var $el = $('.mobile-header [data-ajax-cart-trigger]'); // Removes url to the cart page so user is not redirected

    $el.attr('href', '#');
    $el.off('click').on('click', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      } // Loads content into ajaxCart container for mobile header


      Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile(); // If user clicks outside the element, toggle the mini cart

      $el.toggleClass('show-mini-cart'); // Calculate height of mini cart

      var announcementHeight = 0;
      var mobileHeaderHeight = parseInt($('.mobile-header').height());

      if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky) {
        announcementHeight = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
      }

      $('.mobile-header .theme-ajax-cart').css({
        height: "calc(100vh - ".concat(mobileHeaderHeight + announcementHeight, "px)")
      });
    });
  },
  showDrawer: function showDrawer() {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');

    $('html').addClass('minicart-open');
  },
  hideDrawer: function hideDrawer() {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');

    $('html').removeClass('minicart-open');
  },
  removeFromCart: function removeFromCart(lineID, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function success(cart) {
        Shopify.theme.jsAjaxCart.updateView();
      },
      error: function error(XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  initializeAjaxCart: function initializeAjaxCart() {
    Shopify.theme.asyncView.load('/cart', // template name
    'ajax' // view name (suffix)
    ).done(function (_ref) {
      var html = _ref.html,
          options = _ref.options;
      $('[data-ajax-cart-content]').html(html.content);

      var cartDetails = $(html.content).find('.ajax-cart__details-wrapper');
      var cartSubtotalHtml = cartDetails.find('.ajax-cart__subtotal .original_price')[0].innerText
      var cartSubtotalValue = parseFloat(cartSubtotalHtml.replace('$', '').replace(',', '')) // Get cart subtotal value

      if ($('.ajax-cart__promo-header').length > 0) {
        Shopify.theme.jsAjaxCart.updateDiscountProgress(cartSubtotalValue) //Pass subtotal value to function
      }

      if (Shopify.theme_settings.show_multiple_currencies) {
        convertCurrencies();
      }
    }).fail(function () {// some error handling
    });
  },
  initializeAjaxCartOnMobile: function initializeAjaxCartOnMobile() {
    this.toggleMiniCart();
    Shopify.theme.asyncView.load('/cart', // template name
    'ajax' // view name (suffix)
    ).done(function (_ref2) {
      var html = _ref2.html,
          options = _ref2.options;
      $('.mobile-header [data-ajax-cart-content]').html(html.content);

      var cartDetails = $(html.content).find('.ajax-cart__details-wrapper');
      var cartSubtotalHtml = cartDetails.find('.ajax-cart__subtotal .original_price')[0].innerText
      var cartSubtotalValue = parseFloat(cartSubtotalHtml.replace('$', '').replace(',', '')) // Get cart subtotal value


      if ($('.ajax-cart__promo-header').length > 0) {
        Shopify.theme.jsAjaxCart.updateDiscountProgress(cartSubtotalValue) //Pass subtotal value to function
      }
      if (Shopify.theme_settings.show_multiple_currencies) {
        convertCurrencies();
      }
    }).fail(function () {// some error handling
    });
  },
  addToCart: function addToCart($addToCartForm) {
    var $addToCartBtn = $addToCartForm.find('.button--add-to-cart');
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $addToCartForm.serialize(),
      beforeSend: function beforeSend() {
        $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
        $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
      },
      success: function success(product) {
        var $el = $('[data-ajax-cart-trigger]');
        $addToCartBtn.find('.checkmark').addClass('checkmark-active');

        function addedToCart() {
          if (!isScreenSizeLarge()) {
            $el = $('.mobile-header [data-ajax-cart-trigger]');
            Shopify.theme.scrollToTop($el);
          } else {
            $el = $('[data-ajax-cart-trigger]');
          }

          $el.addClass('show-mini-cart');
          $addToCartBtn.find('span').removeClass('fadeInDown');
        }

        window.setTimeout(function () {
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
          $addToCartBtn.find('.text, .icon').removeClass('zoomOut').addClass('fadeInDown');
          $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);
        }, 1000);
        // if freebie added to cart don't show drawer
        if ( $addToCartForm.hasClass('is-freebie-form') ) {
          $('[data-template="cart"] .freebie-popup').fadeOut(300);
          Shopify.theme.jsAjaxCart.updateView();
        } else {
          Shopify.theme.jsAjaxCart.showDrawer();
          Shopify.theme.jsAjaxCart.updateView();
        }

        if (Shopify.theme.jsCart) {
          var _$$ajax;

          $.ajax((_$$ajax = {
            dataType: "json",
            async: false,
            cache: false
          }, _defineProperty(_$$ajax, "dataType", 'html'), _defineProperty(_$$ajax, "url", "/cart"), _defineProperty(_$$ajax, "success", function success(html) {
            var cartForm = $(html).find('.cart__form');
            $('.cart__form').replaceWith(cartForm);

            if (Shopify.theme_settings.show_multiple_currencies) {
              convertCurrencies();
            }
          }), _$$ajax));
        }
      },
      error: function error(XMLHttpRequest) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
        var cartWarning = "<p class=\"cart-warning__message animated bounceIn\">".concat(response.replace('All 1 ', 'All '), "</p>");
        $('.warning').remove();
        $addToCartForm.find('.cart-warning').html(cartWarning);
        $addToCartBtn.removeAttr('disabled').removeClass('disabled');
        $addToCartBtn.find('.icon').removeClass('zoomOut').addClass('zoomIn');
        $addToCartBtn.find('.text').text(Shopify.translation.addToCart).removeClass('zoomOut').addClass('zoomIn');
      }
    });
  },
  updateView: function updateView() {
    Shopify.theme.asyncView.load('/cart', // template name
    'ajax' // view name (suffix)
    ).done(function (_ref3) {
      var html = _ref3.html,
          options = _ref3.options;

      if (options.item_count > 0) {
        var itemList = $(html.content).find('.ajax-cart__list');
        var cartDetails = $(html.content).find('.ajax-cart__details-wrapper');

        var cartSubtotalHtml = cartDetails.find('.ajax-cart__subtotal .original_price')[0].innerText
        var cartSubtotalValue = parseFloat(cartSubtotalHtml.replace('$', '').replace(',', '')) // Get cart subtotal value

        if ($('.ajax-cart__promo-header').length > 0) {
          Shopify.theme.jsAjaxCart.updateDiscountProgress(cartSubtotalValue) //Pass subtotal value to function
        }
        
        $('.ajax-cart__list').replaceWith(itemList); 
        $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(`Cart (${options.item_count})`);
        $('.cart__count--text[data-bind="itemCount"]').text(options.item_count); 
        
        // Update freeshipping when cart is updated
        if(cartSubtotalValue > 99.99 && $('.cart__shipping_total.free_shipping').length > 0){
          $('.cart__shipping_total.free_shipping').removeClass('is-hidden')
        } else {
          $('.cart__shipping_total.free_shipping').addClass('is-hidden')
        }

        // mobile cart icon
        if( options.item_count == 1 ) {

          // .cart-mobile icon with dot, .cart-2-mobile icon without dot
          if( $('.decoy').hasClass('hide') ) {
            $('.decoy').removeClass('hide');
          }
          if( $('.cart-mobile').css('display') !== 'block') {
            $('.cart-mobile--decoy').show();
          }
          $('.cart-2-mobile').hide();
          if( $('.cart-2--decoy').css('display') == 'inline' ) {
            $('.cart-2--decoy').hide();
          }
        }
        
      } else {
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
        $('.header-cart__count[data-bind="itemCount"]').text('Cart (0)');

        // mobile cart icon
        if( $('.decoy').hasClass('hide') ) {
          $('.decoy').removeClass('hide');
        }
        $('.cart-mobile--decoy').hide();
        $('.cart-2--decoy').show();
        $('.cart-mobile').hide();
      }

      if (Shopify.theme_settings.show_multiple_currencies) {
        convertCurrencies();
      }
    }).fail(function () {// some error handling
    });
  },
  unload: function unload($section) {
    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  },
  updateDiscountProgress: function(cartTotal){
    var miniCartPromoData = window.cart_promo_data
    var highestPromoGoal = Math.max(...miniCartPromoData.map(o => o.tier_goal))
    var getTierValue = miniCartPromoData.filter(promo => promo.tier_goal >= cartTotal)
    var finalTierValue = (getTierValue.length <= 0) ? miniCartPromoData.filter(promo => promo.tier_goal == highestPromoGoal) : getTierValue // If the total is already greater than threshold, get the biggest threshold
    var computePercentage = ((cartTotal/finalTierValue[0].tier_goal) > 1) ? 100 : (cartTotal/finalTierValue[0].tier_goal)*100
    var remainingSpend = finalTierValue[0].tier_goal - cartTotal

    // promo messages
    var defaultMessage = `Spend $${ remainingSpend.toFixed(2) } more to get ${ finalTierValue[0].tier_discount }% off`
    var completedGoals = `You have received ${ finalTierValue[0].tier_discount }% discount!`
    var displayMessage = (computePercentage >= 100) ? completedGoals : defaultMessage

    //HTML markups
    var progressBarHeader = $('.ajax-cart__promo-header .promo-header__progress-bar .progress-bar-header')
    var progressBar = $('.ajax-cart__promo-header .promo-header__progress-bar .progress-percentage')
    progressBar.css('width', `${computePercentage}%`)
    progressBarHeader.empty()
    progressBarHeader.append(displayMessage)
  }
};